export const LANG = {
  es: {
    LANGUAGE: 'es',
    ARTICLES: {
      QUESTIONS: {
        AGREE_INFO_RAPPI:
          '¿Estás conforme con la información brindada por tu Rappi?',
        HOW_SOLVE_YOUR_PROBLEM: '¿Cómo te gustaría que resolvamos tu problema?',
        KIND_OF_DOUBT: 'Tipo de duda',
        KIND_OF_DAMAGE_ORDER: '¿Qué tipo de daño tuvo tu pedido?',
        PRODUCT_BAD_STATUS: '¿Qué producto te llegó en mal estado?',
        USER_COMMENT: 'Comentario de usuario:',
        PRODUCT_DESCRIPTION: 'Productos relacionados en esta orden',
      },
    },
    HOME: {
      TITLE: 'Pagina Principal',
    },
    NOT_FOUND: {
      TITLE: 'Lo sentimos, no encontramos la página que buscas.',
    },
    WIDGETS: {
      BILLING_INFORMATION: {
        CHARGE_DEDUCTED: 'Cargo neto a tu tarjeta',
        COUPON_DISCOUNT: 'Descuentos por cupón',
        DELIVERY_COST: 'Costo del domicilio',
        DIFFS_PERSONAL_SHOPPER: 'Diferencia de precio personal shopper',
        DISCOUNTS: 'Descuentos',
        OTHER_TOTAL_CHARGES: 'Otros cobros',
        PRIME_DISCOUNT: 'Descuento Prime',
        PRODUCT_DISCOUNT_BY_RAPPI: 'Descuentos de productos por rappi.',
        PRODUCT_DISCOUNT_BY_STORE: 'Descuentos de productos por tienda',
        PROMOTION_DISCOUNT: 'Descuento por promoción',
        SUPPORT_DISCOUNT: 'Descuentos por Lupe',
        SUBTOTAL_PRODUCTS: 'Subtotal productos',
        TOTAL_COSTS: 'Total costos',
        TOTAL_DISCOUNTS: 'Total descuentos',
        TOTAL_PAID_BY: 'Total pagado con ',
        TOTAL_PAYMENTS: 'Pagos totales',
        TRANSACTIONS_TO_YOUR_CARD: 'Transacciones a la tarjeta',
        WHIM_COST: 'Costo del antojo',
      },
      CALL_RT: {
        YOUR_RAPPI: 'Tu Rappi',
      },
      CALL_RESTAURANT: {
        TITLE: 'Llamar a restaurante',
        YOUR_ORDER_ID: 'Tu código de orden es',
      },
      CALL_SUPPORT: {
        TITLE: 'Llamar a soporte',
        HOW_CALL: '¿ Cómo quieres llamar ?',
        PHONE: 'Teléfono',
        DATA: 'Datos',
        SIMPLE_CALL_SUPPORT: 'llama a soporte',
        THIS_IS_AN_ERROR: 'Si crees que esto es un error, ',
      },
      CLOSE_REQUEST: {
        TITLE: 'Finalizar pedido',
      },
      COMMON: {
        MESSAGE_SEND: '¡Mensaje enviado!',
        CONTACT_EMAIL: 'Te contactaremos a tu email',
        LEGAL_TIME: 'En menos de 72 horas tendrá una respuesta.',
        AND_SUPPORT_SECTION_APP: 'y en la sección de Soporte en el app',
        UNDERSTOOD: 'Entendido',
        OK: 'OK!',
        RATE_US: 'Por favor califique nuestro servicio...',
        REQUEST_ERROR:
          'No recibimos tu solicitud por favor intenta de nuevo más tarde.',
        DOWNLOAD_DOCUMENT_COPY: 'Puedes descargar una copia de tu reclamo',
        HERE: 'aquí',
        REQUEST_SUBMITTED: 'Solicitud enviada',
        CONTACT_EMAIL_REGISTERED:
          'Te contactaremos al correo electrónico que registraste en el formulario',
        DOWNLOAD_REQUEST_COPY: 'Puedes descargar una copia de tu solicitud,',
      },
      DEEP_LINK_CART: {
        ALREADY_APPLIED_RAPPICREDITS:
          'Ya hemos aplicado Créditos a tu cuenta para que pidas lo que quieras.',
      },
      OPTION_LIST: {
        TITLE: 'Elija una opción',
        PLEASE_COMPLETE: 'Por favor comentanos {question}',
      },
      RT_DISPERSION: {
        GET_INTO: 'Ingrese',
        AMOUNT: 'el monto',
        CONFIRMATION: '¡Hemos recibido tu solicitud de dispersion!',
        IN_REVISION:
          'Ya estamos revisando tu solicitud, en pocos minutos te daremos la respuesta',
      },
      TIMER: {
        IMMEDIATE_HELP: '¿Necesitas ayuda inmediata?',
        IN_THE_NEXT: 'Durante los próximos',
        MINUTES_OPEN_ORDER:
          'minutos este pedido quedará abierto para solucionar cualquier inconveniente',
        DIALOG_TITLE: 'Información',
        DIALOG_TEXT:
          'Si necesitas ayuda para este pedido, ingresa al Centro de Ayuda',
        DIALOG_CLOSE_BUTTON: 'Pedir Ayuda',
      },
      TRANSACTION_DETAIL: {
        TYPE: 'Tipo',
        AMOUNT: 'Cantidad',
        DATE: 'Fecha',
        COPY:
          'En la siguiente tabla puedes ver las distintas transacciones realizadas a tu tarjeta. En ocasiones hacemos una preautorización a tu cuenta, ésto no es un cobro como tal sino una reserva que nos permite comprobar que tengas el saldo suficiente para pagar el pedido al momento de la entrega.',
        INFO_BOX: {
          COPY:
            'Dependiendo de tu banco, se podra demorar un tiempo en actualizar',
        },
        TOTAL_COPY: 'Total pagado'
      },
      PRODUCTS_WRAPPER: {
        WHIMS: 'Antojos',
      },
      INPUT: {
        MAX_LENGTH: 'Ha alcanzado el máximo de caracteres',
      },
      TEXT_AREA: {
        TITLE: 'Escríbenos aquí',
        PLACEHOLDER: 'Escríbenos tu mensaje',
      },
      BUTTON: {
        SEND: 'Enviar',
      },
      CLOSE_REORDER_PRODUCTS_FLOW_WIDGET: {
        COVID_19:
          'Debido al escenario que estamos presenciando y al incremento de la demanda, nuestros servicios estan operando a máxima capacidad. Esperamos que entienda que nuestra respuesta puede tomar un poco más de lo habitual.',
      },
      HELP_OPTIONS: {
        TITLE: '¿Tienes problemas con tu pedido?',
      },
      MULTIPLE_ATTENTION_CHANNELS: {
        TITLE: 'Por favor, proporcione detalles adicionales',
        BODY: 'Cuentanos en detalle que pasó',
        CHAT: "Ó Chat",
        EMAIL: "Enviar",
        CHANNEL_SUBTITLE: 'Canal por el que quieres ser atendido',
        ONLY_ONE_CHANNEL_CHAT: 'Volver a mi chat',
        ONLY_ONE_CHANNEL_TICKET: 'Volver a mi solicitud'
      },
      COST_DISCOUNTS: {
        COST_MESSAGE: 'Tu cobro',
        COST_TITLE: 'Costos',
        DISCOUNT_TITLE: 'Descuentos',
        IVA: 'Todos los costos incluyen IVA',
        MODAL_SERVICE_FEE: {
          TITLE: 'Tasa de servicio (Servicio)',
          TEXT:
            'Es una tasa adicional que cobra la plataforma Rappi al usuario Consumidor en algunas compras que estos realizan de los aliados comerciales de Rappi. Esta tarifa se cobra para ayudar a cubrir los costos de tecnología, desarrollo de nuevas funciones en la aplicación, acciones de mercadeo y para cubrir los costos de las plataformas de procesamiento de pagos.',
        },
      },
      PAYMENTS_RT: {
        PUBLIC_COMMENT_RANGE: 'Fecha: {range}',
        PUBLIC_COMMENT_AMOUNT: 'Monto: {amount}',
        NO_PAYMENTS: 'No se encontraron registros',
        PAYMENTS_SELECT_WARNING_TOAST:
          'Por favor seleccione un rango de fechas.',
        PAYMENTS_TEXT_TOAST: 'Hemos hecho un pago a tu cuenta registrada.',
        PAYMENTS_TEXT_FIRST: 'Hemos hecho un pago a tu cuenta registrada por',
        PAYMENTS_TEXT_LAST:
          'cualquier inquietud adicional sobre este pago por favor hacerla desde las opciones de tu balance sobre deudas o ganancia.',
        USER_DEBT:
          'La deuda en este periodo fue mayor a las ganancias y por eso no se realizo ningún deposito.',
        DATE_PLACEHOLDER: 'Seleccione la fecha',
        AMOUNT_PLACEHOLDER: 'Monto Pendiente (opcional)',
      },
      SCREEN_SATISFACTION: {
        TITLE: 'Necesito ayuda',
        MANDATORY_MSJ: 'Obligatorio',
      },
      PRODUCTS_LIST: {
        TITLE: 'Resumen de Productos',
        DELETED_TITLE: 'Eliminados',
        FRESHNESS_GUARANTEE: '¿Qué producto no estaba fresco?',
        FRESHNESS_COUNTER_TITLE: 'Selecciona las unidades'
      },
      ZENDESK_ARTICLE: {
        RETURN_BUTTON: 'Atrás'
      },
    },
    COMPONENTS: {
      PRODUCT: {
        UNIT: 'Unidad',
        UNITS: 'Unidades',
      },
      INFO_BOX: {
        COPY:
          '¡Gracias por tu respuesta! La usaremos para mejorar tu experiencia.',
      },
      ORDER_PRODUCT: {
        UNIT: 'Unidad',
        UNITS: 'Unidades',
        HIDE: 'Ocultar',
        SHOW: 'Mostrar',
      },
      PRODUCTS_WRAPPER: {
        TITLE: '¿Qué producto te hizo falta?'
      }
    },
    COMMON: {
      YES: 'Si',
      NO: 'No',
      COPY_TO_CLIPBOARD: 'Copiado al portapapeles',
      PHONE: 'Teléfono',
      COSTS: 'Costos',
      TIP: 'Propina',
      RAPPI_PAY: 'Rappipay',
      RAPPI_CREDITS: 'Créditos',
      MIN_CHARACTERS: {
        TEXT_AREA: 'Campo de Texto',
        BASE:
          '@:COMMON.MIN_CHARACTERS.TEXT_AREA requiere un mínimo de caracteres de {minLength}',
      },
      REQUIRED_IMAGE: {
        BASE: 'Se requiere al menos {n} imagen',
      },
      REQUIRED_PRODUCT: {
        BASE: 'Debe seleccionar al menos un producto.',
        OVERLOAD:
          'Si tu pedido no fue entregado, por favor crea la solicitud por pedido no entregado',
      },
      REQUIRED_INPUT: 'Por favor llene el campo de texto',
      SECONDS: 'Segundos',
      MINUTES: 'Minutos',
      HOURS: 'Horas',
      DAYS: 'Días',
      WAIT_TIME: 'Tiempo de espera',
      ERROR_MESSAGE: 'Lo sentimos, ha ocurrido un error.'
    },
    MODALS: {
      COMPENSATION: {
        COMPENSATION_QUESTION: '¿Cómo quieres que te compensemos?',
        RAPPICREDITCS_REFUND: 'Reeembolso en Créditos',
        PRODUCTS_RESHIP: 'Reenvío de productos faltantes',
        REFUND_TEXT: 'El valor de los pedidos faltantes fue $',
      },
    },
    PAYMENT_METHOD: {
      CASH: 'Efectivo',
      CC: 'Tarjeta de crédito',
      DC: 'Tarjeta débito',
      PAYPAL: 'PayPal',
      POS_TERMINAL: 'Datáfono',
      TERMINAL: 'Terminal',
      RAPPI_PAY: 'Rappipay',
    },
    MAXLENGTH_MESSAGE: 'Caracteres permitidos',
  },
}
